import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
  vaporThemeExtension,
  signInPage,
  analyticsApi,
  scmIntegrationsApi,
  scmAuthApi,
  userSettingsStorageApi,
} from '../../extensions';

export const appModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    vaporThemeExtension,
    signInPage,
    analyticsApi,
    scmIntegrationsApi,
    scmAuthApi,
    userSettingsStorageApi,
  ],
});